<template>
  <div class="grid grid-pad box-size">
    <div class="col-1-1 box-size">
      <isIEOrEdge></isIEOrEdge>
      <div class="dashboard text-dark">
        <div class="box box-overview flex pad-0" v-if="isOnboarding">
          <div class="flex-1 box-overview__name">
            <h1>{{ $t('vue2.dashboard.welcome') }} {{ userName }}!</h1>
            <h1>{{ $t('vue2.dashboard.start_by_setting_up') }} {{ schoolName }}</h1>
          </div>
          <button @click="openSetupWidget">{{ $t('vue2.dashboard.follow_the_steps') }}</button>
          <div class="flex bg-light-blue flex-1 steps-graph">
            <div>
              <h2>{{ $t('vue2.dashboard.steps_completed') }}</h2>
              <doughnut :animate="true" :steps="steps.length" :stepNum="howManyDone"></doughnut>
            </div>
          </div>
        </div>
        <div v-else>
          <h1>{{ schoolName }} </h1>
        </div>
        <div class="dashboard-boxes">
          <dashboardBox v-for="(step, key) in steps" v-if="key < 4"
                        :step="step"
                        :isOnboarding="isOnboarding"
                        :key="step.dbName">
          </dashboardBox>
        </div>
        <div class="dashboard-boxes">
          <dashboardBox v-for="(step, key) in steps" v-if="key >= 4"
                        :step="step"
                        :isOnboarding="isOnboarding"
                        :key="step.dbName">
          </dashboardBox>
        </div>
        <div class="slide-up" :class="{'active': showSlideUp}">
          <div class="slide-up__close" @click="setShowSlideUp(false)">
            <span class="icon-cross2"></span>
          </div>
          <div class="slide-up__content box">
            <vacationDaySelector v-show="showSlideUp"
                                 :school-id="schoolId"
                                 :emit-event-on-load="false"
                                 :initial-year="schoolYear"
                                 @schoolDays="setSchoolDays">
            </vacationDaySelector>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="modal-mask" v-show="showSlideUp"></div>
    </transition>
  </div>
</template>

<script>
  import doughnut from '../AppGraphs/StepDoughnut'
  import dashboardBox from './DashboardBox'
  import eventbus from '../../eventbus'
  import vacationDaySelector from '../VacationDaysSelector/VacationDaysSelector'
  import isIEOrEdge from '../common/IEAndEdgeWarning'

  export default {
    components: {doughnut, dashboardBox, vacationDaySelector, isIEOrEdge},
    computed: {
      showSetupWidget () {
        return eventbus.showSetupWidget
      },
      schoolYear () {
        return this.$store.state.selectedSchoolYear
      },
      user () {
        return this.$store.state.user
      },
      userSettings () {
        return this.$store.state.userSettings
      },
      klassCals () {
        return this.$store.getters.klassCalendars
      },
      userCals () {
        return this.$store.getters.userCalendars
      },
      roomCals () {
        return this.$store.getters.roomCalendars
      },
      mergeCals () {
        return this.$store.getters.mergeCalendars
      },
      steps () {
        if (this.country === 'dk') {
          return this.stepsDK
        } else if (this.country === 'no') {
          return this.stepsNO
        } else {
          return this.stepsEN
        }
      },
      howManyDone () {
        let doneSteps = this.steps.filter(obj => {
          return obj.done === true
        })
        return doneSteps.length
      }
    },
    watch: {
      userSettings () {
        const obj = this.userSettings
        this.progressed = Object.keys(obj).filter(key => {
          return key.startsWith('setup_widget_progress')
        })
        this.checkProgress()
      },
      klassCals (val) {
        this.setNumberOfCals('setup_widget_progress_klass', val.length)
      },
      userCals (val) {
        this.setNumberOfCals('setup_widget_progress_users', val.length)
      },
      roomCals (val) {
        this.setNumberOfCals('setup_widget_progress_rooms', val.length)
      },
      mergeCals (val) {
        this.setNumberOfCals('setup_widget_progress_merge', val.length)
      }
    },
    data () {
      return {
        schoolId: 0,
        userName: '',
        schoolName: '',
        isOnboarding: false,
        progressed: [],
        showSlideUp: false,
        country: 'EN',
        showTutorial: false,
        videoId: '5gjODdkqRDI',
        videoVars: {
          autoplay: 0,
          modestbranding: 1, // remove youtube logo
          rel: 0 // related videos will come from the same channel as the video that was just played
        },
        stepsDK: [
          {
            title: 'Klasser',
            icon: 'icon-calendar4',
            buttonText: '+ Opret klasser',
            guide: 'https://www.youtube.com/watch?v=5gjODdkqRDI&feature=youtu.be',
            videoid: '5gjODdkqRDI',
            guideDuration: '1:01',
            dbName: 'setup_widget_progress_klass',
            done: false,
            stepNum: 1,
            number: 0,
            action: () => {
              eventbus.createKlassModal = true
            }
          },
          {
            title: 'Undervisere',
            icon: 'icon-users',
            buttonText: '+ Opret undervisere',
            guide: 'https://www.youtube.com/watch?v=YtujiFzH50A&feature=youtu.be',
            videoid: 'YtujiFzH50A',
            guideDuration: '0:41',
            dbName: 'setup_widget_progress_users',
            done: false,
            stepNum: 2,
            number: 0,
            action: () => {
              eventbus.createUserModal = true
            }
          },
          {
            title: 'Lokaler',
            icon: 'icon-location',
            buttonText: '+ Opret lokaler',
            guide: 'https://www.youtube.com/watch?v=2XQjHWLvyrM&feature=youtu.be',
            videoid: '2XQjHWLvyrM',
            guideDuration: '0:39',
            dbName: 'setup_widget_progress_rooms',
            done: false,
            stepNum: 3,
            number: 0,
            action: () => {
              eventbus.createCalendarsType = 'merge'
            }
          },
          {
            title: 'Skoledage',
            icon: 'icon-calendar2',
            guide: 'https://www.youtube.com/watch?v=0XB5A0xr-N0&feature=youtu.be',
            videoid: '0XB5A0xr-N0',
            guideDuration: '0:39',
            buttonText: 'Vælg feriedage',
            dbName: 'setup_widget_progress_vacation',
            done: false,
            stepNum: 4,
            number: 0,
            action: () => {
              this.$store.dispatch('updateUserSettings', {'setup_widget_progress_vacation': true})
              if (window.Intercom) {
                window.Intercom('trackEvent', 'Visited Holiday Calendar')
              }
              this.setShowSlideUp('true')
            }
          },
          {
            title: 'Fletteskemaer',
            icon: '',
            guide: 'https://www.youtube.com/watch?time_continue=2&v=VNt1m80YEsI',
            videoid: 'VNt1m80YEsI',
            guideDuration: '0:39',
            buttonText: '+ Opret fletteskemaer',
            dbName: 'setup_widget_progress_merge',
            done: false,
            stepNum: 5,
            number: 0,
            action: () => {
              eventbus.createCalendarsType = 'merge'
            }
          },
          /*
          {
            title: 'Subjects',
            icon: '',
            guide: 'https://youtu.be/EpEfabVl7yw',
            guideDuration: '2:31',
            buttonText: '',
            dbName: 'setup_widget_progress_subjects',
            done: false,
            desc: 'Go to classes to create subjects for that specifik class',
            stepNum: 6
          },
          */
          {
            title: 'Skemalægning i klasser',
            icon: '',
            guide: 'https://www.youtube.com/watch?v=7NR8_EygcoM&feature=youtu.be',
            videoid: '7NR8_EygcoM',
            guideDuration: '2:25',
            dbName: 'setup_widget_progress_scheduling',
            done: false,
            stepNum: 6,
            desc: 'Når du har oprettet klasser, undervisere og fag, så er du klar til at lægge skemaer for klasserne.',
            uniClass: 'text-left'
          }
        ],
        stepsNO: [
          {
            title: 'Klasser',
            icon: 'icon-calendar4',
            buttonText: '+ Opprett klasser',
            guide: 'https://www.youtube.com/watch?v=P9lc_0-64kc&feature=youtu.be',
            videoid: 'P9lc_0-64kc',
            guideDuration: '0:36',
            dbName: 'setup_widget_progress_klass',
            done: false,
            stepNum: 1,
            number: 0,
            action: () => {
              eventbus.createKlassModal = true
            }
          },
          {
            title: 'Lærere',
            icon: 'icon-users',
            buttonText: '+ Opprett lærere',
            guide: 'https://www.youtube.com/watch?v=X-w0i3MFeL4&feature=youtu.be',
            videoid: 'X-w0i3MFeL4',
            guideDuration: '0:44',
            dbName: 'setup_widget_progress_users',
            done: false,
            stepNum: 2,
            number: 0,
            action: () => {
              eventbus.createUserModal = true
            }
          },
          {
            title: 'Lokaler',
            icon: 'icon-location',
            buttonText: '+ Opprett lokaler',
            guide: 'https://www.youtube.com/watch?v=8FoyUOiwdPk&feature=youtu.be',
            videoid: '8FoyUOiwdPk',
            guideDuration: '0:37',
            dbName: 'setup_widget_progress_rooms',
            done: false,
            stepNum: 3,
            number: 0,
            action: () => {
              eventbus.createCalendarsType = 'merge'
            }
          },
          {
            title: 'Skoledager',
            icon: 'icon-calendar2',
            guide: 'https://www.youtube.com/watch?v=KmLDUVlzhXA&feature=youtu.be',
            videoid: 'KmLDUVlzhXA',
            guideDuration: '0:39',
            buttonText: 'Legg inn fridager',
            dbName: 'setup_widget_progress_vacation',
            done: false,
            stepNum: 4,
            number: 0,
            action: () => {
              this.$store.dispatch('updateUserSettings', {'setup_widget_progress_vacation': true})
              this.setShowSlideUp('true')
            }
          },
          {
            title: 'Fellestimeplaner',
            icon: '',
            guide: 'https://www.youtube.com/watch?v=39daX1u0238&feature=youtu.be',
            videoid: '39daX1u0238',
            guideDuration: '2:09',
            buttonText: '+ Opprett fellestimeplaner',
            dbName: 'setup_widget_progress_merge',
            done: false,
            stepNum: 5,
            number: 0,
            action: () => {
              eventbus.createCalendarsType = 'merge'
            }
          },
          /*
          {
            title: 'Subjects',
            icon: '',
            guide: 'https://youtu.be/EpEfabVl7yw',
            guideDuration: '2:31',
            buttonText: '',
            dbName: 'setup_widget_progress_subjects',
            done: false,
            desc: 'Gå til en klasse for å opprette fag for den spesifikke klassen',
            stepNum: 6
          },
          */
          {
            title: 'Timeplanlegging i klasser',
            icon: '',
            guide: 'https://www.youtube.com/watch?v=s6b7b07ZHl0&feature=youtu.be',
            videoid: 's6b7b07ZHl0',
            guideDuration: '2:25',
            dbName: 'setup_widget_progress_scheduling',
            done: false,
            stepNum: 6,
            desc: 'Du må opprette klasser, lærere og fag før du kan lage timeplaner.',
            uniClass: 'text-left'
          }
        ],
        stepsEN: [
          {
            title: 'Classes',
            icon: 'icon-calendar4',
            buttonText: '+ Create Classes',
            guide: 'https://youtu.be/WdXydJxGFpI',
            videoid: 'WdXydJxGFpI',
            guideDuration: '0:52',
            dbName: 'setup_widget_progress_klass',
            done: false,
            stepNum: 1,
            number: 0,
            action: () => {
              eventbus.createKlassModal = true
            }
          },
          {
            title: 'Teachers',
            icon: 'icon-users',
            buttonText: '+ Create teachers',
            guide: 'https://youtu.be/D83kXuPIZzE',
            videoid: 'D83kXuPIZzE',
            guideDuration: '0:43',
            dbName: 'setup_widget_progress_users',
            done: false,
            stepNum: 2,
            number: 0,
            action: () => {
              eventbus.createUserModal = true
            }
          },
          {
            title: 'Classrooms',
            icon: 'icon-location',
            buttonText: '+ Create classrooms',
            guide: 'https://youtu.be/UBI-WnWOtdQ',
            videoid: 'UBI-WnWOtdQ',
            guideDuration: '1:01',
            dbName: 'setup_widget_progress_rooms',
            done: false,
            stepNum: 3,
            number: 0,
            action: () => {
              eventbus.createCalendarsType = 'merge'
            }
          },
          {
            title: 'School days',
            icon: 'icon-calendar2',
            guide: 'https://youtu.be/CkUvNQQgMoQ',
            videoid: 'CkUvNQQgMoQ',
            guideDuration: '0:36',
            buttonText: 'Choose holidays',
            dbName: 'setup_widget_progress_vacation',
            done: false,
            stepNum: 4,
            number: 0,
            action: () => {
              this.$store.dispatch('updateUserSettings', {'setup_widget_progress_vacation': true})
              if (window.Intercom) {
                window.Intercom('trackEvent', 'Visited Holiday Calendar')
              }
              this.setShowSlideUp('true')
            }
          },
          {
            title: 'Shared calendar',
            icon: '',
            guide: 'https://youtu.be/aIvpXbHwYeA',
            videoid: 'aIvpXbHwYeA',
            guideDuration: '2:56',
            buttonText: '+ Create breaks',
            dbName: 'setup_widget_progress_merge',
            done: false,
            stepNum: 5,
            number: 0,
            action: () => {
              eventbus.createCalendarsType = 'merge'
            }
          },
          {
            title: 'Subjects',
            icon: '',
            guide: 'https://youtu.be/EpEfabVl7yw',
            videoid: 'EpEfabVl7yw',
            guideDuration: '2:31',
            buttonText: '',
            dbName: 'setup_widget_progress_subjects',
            done: false,
            desc: 'Go to classes to create subjects for that specific class',
            stepNum: 6,
            uniClass: 'text-left'
          },
          {
            title: 'Start scheduling',
            icon: '',
            guide: 'https://youtu.be/UXZpf-wAh-U',
            videoid: 'UXZpf-wAh-U',
            guideDuration: '3:31',
            dbName: 'setup_widget_progress_scheduling',
            done: false,
            stepNum: 7,
            desc: 'You have to create classes, teachers and subjects before you can schedule a class',
            uniClass: 'text-left'
          }
        ]
      }
    },
    methods: {
      openSetupWidget () {
        eventbus.showSetupWidget = true
      },
      checkProgress () {
        for (let i = 0; i < this.progressed.length; i++) {
          for (let j = 0; j < this.steps.length; j++) {
            if (this.steps[j].dbName === this.progressed[i]) {
              this.steps[j].done = true
            }
          }
        }
      },
      findStepIndex (dbName) {
        return this.steps.map(step => step.dbName).indexOf(dbName)
      },
      setNumberOfCals (dbName, number) {
        this.steps[this.findStepIndex(dbName)].number = number
      },
      setSchoolDays (days) {
        this.setNumberOfCals('setup_widget_progress_vacation', days)
      },
      setShowSlideUp (boolean) {
        if (boolean) {
          this.showSlideUp = true
        } else {
          this.showSlideUp = false
        }
      }
    },
    beforeMount () {
      this.userName = window.USER.name
      this.schoolName = window.SCHOOL.name
      this.schoolId = window.SCHOOL.id
      this.country = window.SCHOOL.country.toLowerCase()
      if (window.SCHOOL.state && window.SCHOOL.state === 'demo') {
        this.isOnboarding = true
      }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/variables.css';

  .dashboard-boxes {
    display: flex;
    margin-top: 10px;
  }

  .box {
    padding: 20px;
    flex: 1;
    margin-right: 10px;
    border-radius: 4px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, .07);
    background: #fff;
    border: 1px solid #d8d8d8;
    position: relative;
  }

  .box:last-child {
    margin-right: 0;
  }

  .box.box-overview {
    padding: 0;
    margin-right: 0;
    justify-content: space-between;
    align-items: center;
  }

  .box-overview__name {
    padding: 20px;
  }

  .steps-graph {
    text-align: center;
    padding: 20px 0;
    max-width: 300px;
  }

  .steps-graph > div {
    width: 300px;
  }

  .slide-up {
    position: fixed;
    z-index: 19998;
    top: 80px;
    left: 0;
    width: 100%;
    height: 100%;
    transform: translateY(102%);
    transition: transform .5s;
    background: #edf0f5;
    padding: 40px;
    max-height: calc(100vh - 40px);
    overflow: auto;
    box-shadow: 0 0 10px -5px rgba(0, 0, 0, 0.2), 0 0 24px 2px rgba(0, 0, 0, 0.14), 0 0 30px 5px rgba(0, 0, 0, 0.12);
  }

  .slide-up.active {
    transform: translateY(0);
  }

  .slide-up__close {
    font-size: 2rem;
    float: right;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }

  .slide-up__content {
    background-color: white;
    padding: 20px;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .15s ease;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .slideInRight-enter-active, .slideInRight-leave-active {
    transition: transform .5s, opacity 0.5s;
  }

  .slideInRight-enter, .slideInRight-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0.9;
    transform: translateY(120%);
  }

  .youtube-container {
    position: fixed;
    z-index: 19997;
    bottom: 100px;
    right: 0;
    border-radius: 4px;
    background: transparent;
    box-shadow: 0 0 4px rgba(0, 0, 0, .14), 0 4px 8px rgba(0, 0, 0, .28);
    border: 1px solid #d8d8d8;
  }

  .youtube-container__close {
    position: absolute;
    z-index: 19998;
    top: -20px;
    right: 10px;
    font-size: 1.75rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 30px 60px -12px rgba(50, 50, 93, .25), 0 18px 36px -18px rgba(0, 0, 0, .3);
    overflow: hidden;
    color: #32325d;
    transition: all .15s;
    border: 1px solid #cccccc;
  }

  .youtube-container__close:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }

</style>



// WEBPACK FOOTER //
// Dashboard.vue?4ff09310